import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { SdfBusyIndicator } from "@synerg/react-components";
import { SessionContext, SessionProvider } from './components/session';
import { ApplicationStateProvider } from './utilities/applicationState';
import { ExperimentalFeaturesProvider } from './utilities/experimentalFeatures';
import OneUxLayout from "./components/oneux-layout";
import SsoLoginPage from './components/loginPage/ssoLoginPage';
import { NotificationProvider } from './components/shared/notifications';
import { AppConfigProvider } from "./utilities/appConfig";

export default function Container() {
	const proxyUrls = [
		'https://local-dss.gslb.es.oneadp.com',
		'http://marketplace-apis-dit.oneadp.com',
		'https://iat-partner-self-service.adp.com',
		'https://partner-self-service.adp.com'
	];
	const isProxy = proxyUrls.indexOf(window.location.hostname) && window.location.pathname === '/login';

	return (
		<ApplicationStateProvider>
			<AppConfigProvider>
				<ExperimentalFeaturesProvider>
					<Switch>
						{isProxy && <Route exact path={'/login'} component={SsoLoginPage} />}
						<SessionProvider>
							<SessionContext.Consumer>
								{(session) => {
									if (session.state === 'LOADING') {
										return (
											<SdfBusyIndicator
												style={{ color: "#1a8099" }}
												size="xl"
												fullScreen={true}
											></SdfBusyIndicator>
										)
									} else {
										return (
											<NotificationProvider>
												<OneUxLayout />
											</NotificationProvider>
										)
									}
								}}
							</SessionContext.Consumer>
						</SessionProvider>
					</Switch>
				</ExperimentalFeaturesProvider>
			</AppConfigProvider>
		</ApplicationStateProvider>
	)
}
